import { useEffect } from 'react';

import { useAcceptsReservations } from 'reservations/account/providers/ConfigProvider';
import { REDIRECT_BASE_404 } from 'reservations/base/constants/redirects';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';

/**
 * NOTE: Route to 404 when booking.acceptsParties is false
 */
export const useRouteIfReservationsDisabled = () => {
  const isAcceptingReservations = useAcceptsReservations();
  const { handleNavigation } = useCustomRouter();

  useEffect(() => {
    if (!isAcceptingReservations) {
      handleNavigation(REDIRECT_BASE_404);
    }
  }, [isAcceptingReservations, handleNavigation]);
};
